import React, { useEffect, useState } from 'react'
import '../Styles/aboutus.css'
import Navbar from '../sections/common/Navbar'
import Footer from '../sections/common/Footer'
import MainAboutUs from '../sections/AboutUs/MainAboutUs'
import AboutChooseUs from '../sections/AboutUs/AboutChooseUs'
import AboutTestimonail from '../sections/AboutUs/AboutTestimonail'
import MissionValue from '../sections/AboutUs/MissionValue'
import Faq from '../sections/common/Faq'
import { detailsPageApi } from '../apis/detailsPages/detailsPagesApi'

function AboutUs() {

    const [details, setDetails] = useState([]);

    const fetchAboutUs = async () => {
        const response = await detailsPageApi("about-us");
        const detailsData = response.data.data.content;
        setDetails(detailsData);
    };

    useEffect(() => {
        fetchAboutUs();
    }, []);

    return (
        <div>
            <Navbar />
            <section className="listing-banner">
                <h1>About Us</h1>
            </section>
            <section className="container blog-details-page-location">
                <p>Home / about-us</p>
            </section>

            <section>
                <MainAboutUs details={details} />
                <AboutChooseUs />
                <MissionValue />
                <AboutTestimonail />
                <div className=" pt-5">
                    <Faq />
                </div>
            </section>

            <Footer />
        </div>
    )
}

export default AboutUs
